import React, { useState } from "react";
import {
  Grid,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { setDoc, collection, doc } from "firebase/firestore";
import { db } from "../../context/firebase";
import { UserAuth } from "../../context/AuthContext";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../../components/Wrappers/Wrappers";

import { useHistory } from "react-router-dom";

export default function StudentDashboard(props) {
  var classes = useStyles();
  var theme = useTheme();
  const navigate = useHistory();
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { user } = UserAuth();
  const handlepdfboard = () => {
    try {
      navigate.push("/student/pdfboard");
    } catch (err) {
      alert(err.message);
    }
  };

  const handlevideoboard = () => {
    try {
      navigate.push("/student/videoboard");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const submitDoubt = async () => {
    const newDocRef = doc(collection(db, "doubts"));
    await setDoc(newDocRef, {
      uid: user.uid,
      query: query,
      queryID: newDocRef.id,
    });
    setQuery("");
    setOpen(false);
  };

  const message = () => {
    alert("ERROR! DATABASE IS EMPTY")
  }

  return (
    <>
      <Grid container spacing={6}>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sm={12}
          spacing={4}
          onClick={() =>
            window.open("https://webexapp.webex.com/meet/abphysicsonline2022")
          }
        >
          <Card className={classes.card}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://i.pcmag.com/imagery/reviews/02W9amqtzy7Lbr0Mprgyg4p-23.fit_scale.size_760x427.v1624312529.jpg"
                title="Online Class"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  JOIN MEETING
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={6} sm={12} spacing={9}>
          <Card className={classes.card} onClick={handlepdfboard}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1632571401005-458e9d244591?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80`}
                title="PDFs"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  PDFs
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* VIDEO Section */}
        <Grid item xs={12} md={6} lg={6} sm={12} spacing={9}>
          <Card className={classes.card} onClick={handlevideoboard}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1612521564381-8b0d19cc4951?ixlib=rb-1.2.1&raw_url=true&q=80&fm=jpg&crop=entropy&cs=tinysrgb&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1097`}
                title="Videos"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  VIDEOS
                </Typography>
                {/* <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography> */}
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Ask your dout section */}
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sm={12}
          spacing={9}
          onMouseEnter={handleClickOpen}
        >
          <Card className={classes.card}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80`}
                title="ASK Your Dout"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  ASK Your Doubt!
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              <h3>{"Ask Your Doubt here?"}</h3>
            </DialogTitle>
            <DialogContent>
              <TextField
                required
                aria-required
                autoFocus
                margin="dense"
                id="doubt"
                label="Write your DOUBT!"
                type="text"
                fullWidth
                onChange={(event) => setQuery(event.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Typography variant="subtitle1" color="secondary">
                Press ESC to cancel
              </Typography>
              <Button
                type="submit"
                onClick={submitDoubt}
                color="primary"
                autoFocus
              >
                ASK!
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>

        {/* Class XI Crash Course */}
        <Grid item xs={12} md={6} lg={6} sm={12} spacing={9}>
          <Card className={classes.card} onClick={message}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1591306208574-969f12f1ebfe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80`}
                title="Crash Course"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Class XI Crash Course
                </Typography>
                {/* <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography> */}
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Class XII Crash Course */}
        <Grid item xs={12} md={6} lg={6} sm={12} spacing={9}>
          <Card className={classes.card} onClick={message}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80`}
                title="Crash Course"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Class XII Crash Course
                </Typography>
                {/* <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography> */}
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
